import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NonBuyingPhysicianService {
  constructor(
    protected occEndPointsService: OccEndpointsService,
    protected http: HttpClient
  ) {}

  verifyNbpAccount(recaptchaToken: string, params?: any): Observable<any> {
    const headers = new HttpHeaders();
    if (recaptchaToken) {
      headers.set('sap-commerce-cloud-captcha-token', recaptchaToken);
    }
    const url = this.occEndPointsService.buildUrl('nbpAccount');
    return this.http.post(url, params, { headers });
  }

  validateAccount(params: any): Observable<any> {
    const url = this.occEndPointsService.buildUrl('validateNbpAccount');
    return this.http.post(url, params);
  }

  registerUser(params: any): Observable<any> {
    const url = this.occEndPointsService.buildUrl('registerNbpAccount');
    return this.http.post(url, params);
  }
}
